// Corporate date-range presets for the Builder filters.
// Each preset resolves to { after, before } as ISO YYYY-MM-DD strings, matching
// the `created_at` gte/lte bounds the EQL filters expect.

import dayjs from "dayjs";

export const DATE_PRESETS = [
  "this_month",
  "last_month",
  "this_quarter",
  "last_quarter",
  "this_year",
  "custom",
];

const iso = (d) => d.format("YYYY-MM-DD");

// The calendar quarter containing `ref`, as a full [start-of-Q1month, end-of-Q3month] range.
const quarterRange = (ref) => {
  const q = Math.floor(ref.month() / 3); // 0..3
  const start = ref.month(q * 3).startOf("month");
  const end = start.add(2, "month").endOf("month");
  return { after: iso(start), before: iso(end) };
};

/**
 * @param {string} key - one of DATE_PRESETS
 * @param {dayjs.Dayjs} [today] - injectable for deterministic tests
 * @returns {{after: string, before: string} | null} null for "custom"
 */
export const computePresetRange = (key, today = dayjs()) => {
  switch (key) {
    case "this_month":
      return { after: iso(today.startOf("month")), before: iso(today.endOf("month")) };
    case "last_month": {
      const d = today.subtract(1, "month");
      return { after: iso(d.startOf("month")), before: iso(d.endOf("month")) };
    }
    case "this_quarter":
      return quarterRange(today);
    case "last_quarter":
      // Any date one quarter back lands in the previous quarter; quarterRange
      // then snaps to that quarter's bounds, handling year rollover.
      return quarterRange(today.subtract(3, "month"));
    case "this_year":
      // Year-to-date: Jan 1 through today, since future reports don't exist.
      return { after: iso(today.startOf("year")), before: iso(today) };
    case "custom":
    default:
      return null;
  }
};
